import React from 'react';
import { useFormContext } from '@context/FormContext';
import { AssetLinks } from '@assets/assets';

const Header: React.FC = () => {
  const { widgetInitVariables } = useFormContext();
  const headerBorderRadius = widgetInitVariables?.branding?.roundCorners ? '8px' : '0px';
  return (
    <div
      className="iLendingCDX-header"
      style={{ borderTopLeftRadius: headerBorderRadius, borderTopRightRadius: headerBorderRadius }}
    >
      <img
        src={AssetLinks?.logo}
        alt=""
        className="iLendingCDX-iLInfinity-logo"
      />
    </div>
  );
};

export default Header;
